import { setupTranslationService } from '@/services/translationService'
import { setupSentryService } from '@/services/SentryService'
import { setupFingerprintService } from '@/services/FingerprintService'

export const setupServices = () => {
  setupTranslationService()
  setupSentryService()
  setupFingerprintService()
}
